import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('billing');

export class Process extends Api {
  constructor(http, config = {}) {
    super(http, url, 'process', config);
  }
}
